import { useGtag } from "../plugins/gtag";

export const GtagInitializer = ({ enabled }: { enabled?: boolean }) => {
  useGtag(enabled);
  return null;
};
